<template>
    <div :id="overlayId" class="contact-details-dialog-container"></div>
    <OverlayPanel
        ref="op"
        :pt="{
            root: { class: 'contact-details-dialog' },
        }"
        :append-to="'#' + overlayId"
    >
        <CopyableText v-if="email" class="orderer-email" :text="email" />
        <CopyableText v-if="phoneNumber" class="orderer-phone" :text="phoneNumber" />
    </OverlayPanel>
</template>

<script setup lang="ts">
    import { v4 as uuidv4 } from "uuid";
    import { ref } from "vue";

    import CopyableText from "./CopyableText.vue";
    import OverlayPanel from "primevue/overlaypanel";

    const overlayId = ref("id-" + uuidv4());

    defineProps<{
        email?: string;
        phoneNumber?: string;
    }>();

    const op = ref();
    function toggle(event) {
        op.value.toggle(event);
    }

    // define exposed
    defineExpose({
        toggle,
    });
</script>

<style lang="scss">
    @use "./../../../../assets/styles/scss/shared/_variables.scss";
    @use "./../../../../assets/styles/scss/shared/_mixins.scss";

    .contact-details-dialog-container {
        display: inline-block;
        position: relative;

        .contact-details-dialog {
            position: absolute !important;
            top: auto !important;
            right: auto !important;
            bottom: 10px !important;
            left: -28px !important;
            background-color: #484848;
            color: white;
            box-shadow: none;

            &:before {
                display: none !important;
            }

            &:after {
                border-top-color: #484848 !important;
                border-bottom-color: rgba(0, 0, 0, 0) !important;
            }

            .orderer-email:not(:last-child) {
                margin-bottom: 0.75em;
            }
        }
    }
</style>
